"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Creates a new list where id will be send to the beginning
 * @param  {String|Int} id
 * @param  {Array} list
 * @return {Array}
 */
function sendToBack(id, list) {
  if (list.length === 1) {
    return list;
  }
  var newList = list.filter(function (item) {
    return item !== id;
  });
  newList = [id].concat(_toConsumableArray(newList));

  return newList;
}

exports.default = sendToBack;